module.exports = __webpack_public_path__ + "static/media/syncWhatsapp_step2_ch.e39c3dd8.jpg";